import React, { useState, useEffect } from 'react';
import { ReactComponent as WhatsAppIcon } from 'src/image/common/whatsapp.svg';
import { ReactComponent as LineIcon } from 'src/image/common/line.svg';
import { ReactComponent as FAQ } from 'src/image/common/link.svg';
import { useLocation } from 'react-router-dom';
import { LocalizedLink } from 'src/components/common/LocalizedLink';
import { getPropertieslist } from '../../API/apiService';

type PropertyData = {
  area_id: number;
  area_name: string;
  area_name_en: string;
  property_id: number;
  chillnn_id: string;
  property_name: string;
  property_name_en: string;
};

type MenuContentProps = {
  closeMenu: () => void;
};

export const MenuContent: React.FC<MenuContentProps> = ({ closeMenu }) => {
  const location = useLocation();
  const [showLocations, setShowLocations] = useState(false);
  const [showMenu, setShowMenu] = useState(false);
  const [isMonthly, setIsMonthly] = useState(false);
  const [isHotel, setIsHotel] = useState(false);
  const [isMagazine, setIsMagazine] = useState(false);
  const [properties, setProperties] = useState<PropertyData[]>([]);

  // 現在の言語コード取得およびリンク先パスの生成
  const currentLang = location.pathname.split('/')[1] || 'en';
  const enPath = location.pathname.replace(/^\/(en|ja)/, '/en');
  const jaPath = location.pathname.replace(/^\/(en|ja)/, '/ja');

  useEffect(() => {
    const currentUrl = location.pathname.toLowerCase();
    setIsMonthly(
      currentUrl.includes('monthly') || currentUrl.includes('inquire')
    );
    setIsHotel(currentUrl.includes('hotel'));
    setIsMagazine(currentUrl.includes('magazine'));

    if (
      (currentUrl.includes('monthly') ||
        currentUrl.includes('hotel') ||
        currentUrl.includes('magazine')) &&
      !currentUrl.includes('admin')
    ) {
      setShowMenu(true);
    } else {
      setShowMenu(false);
    }

    getPropertieslist()
      .then((response: any) => {
        if (response.data && Array.isArray(response.data.data)) {
          setProperties(response.data.data);
        } else {
          console.error(
            'getPropertieslist: response.data.data is not an array:',
            response.data
          );
        }
      })
      .catch((error: any) => {
        console.error('Failed to fetch properties:', error);
      });
  }, [location]);

  const handleLocationsClick = () => {
    setShowLocations(!showLocations);
  };

  // ロゴのリンク先は URL により /hotel, /magazine, /monthly を切り替え
  const currentUrl = location.pathname.toLowerCase();
  const logoLink = currentUrl.includes('hotel')
    ? '/hotel'
    : currentUrl.includes('magazine')
      ? '/magazine'
      : '/monthly';

  if (!showMenu) {
    return null;
  }

  return (
    <div className="w-full text-black text-start bg-whiteYellow">
      <LocalizedLink to={logoLink} onClick={closeMenu}>
        <div className="text-base leading-[17.6px]">
          The (Apartment)
          <br />
          Hotel
        </div>
      </LocalizedLink>

      {isMagazine ? (
        <div className="flex flex-col items-start space-y-4 mt-10">
          <LocalizedLink
            to="/hotel"
            className="underline font-medium text-lg"
            onClick={closeMenu}
          >
            Hotel
          </LocalizedLink>
          <LocalizedLink
            to="/monthly"
            className="underline font-medium text-lg"
            onClick={closeMenu}
          >
            Monthly
          </LocalizedLink>
        </div>
      ) : (
        <div>
          <div className="flex flex-col items-start space-y-4 mt-10">
            <button
              onClick={handleLocationsClick}
              className="underline font-medium text-lg"
            >
              Locations {showLocations ? '-' : '+'}
            </button>
            {/* //TODO:ここの .filter((item) => item.property_id !== 3 && item.property_id !== 4)は、後で消す。 */}
            {showLocations && (
              <div className="mt-2 ml-4 space-y-2 text-start">
                {properties.map((item) => {
                  // 言語に応じたプロパティ名を切り替え
                  const propertyName =
                    currentLang === 'ja'
                      ? item.property_name
                      : item.property_name_en;
                  if (isMonthly) {
                    return (
                      <LocalizedLink
                        key={item.property_id}
                        to={`/monthly/${item.property_id}`}
                        className="underline block text-lg cursor-pointer"
                        onClick={closeMenu}
                      >
                        {propertyName}
                      </LocalizedLink>
                    );
                  } else if (isHotel) {
                    return (
                      <LocalizedLink
                        key={item.property_id}
                        to={`/hotel/${item.property_id}`}
                        className="underline block text-lg cursor-pointer"
                        onClick={closeMenu}
                      >
                        {propertyName}
                      </LocalizedLink>
                    );
                  } else {
                    return (
                      <span key={item.property_id} className="text-lg">
                        {propertyName}
                      </span>
                    );
                  }
                })}
              </div>
            )}

            <LocalizedLink
              to="/magazine"
              className="underline font-medium text-lg"
              onClick={closeMenu}
            >
              Magazine
            </LocalizedLink>
            <LocalizedLink
              to="/faq"
              className="underline font-medium text-lg flex items-center"
              onClick={closeMenu}
            >
              FAQ
              <div className="w-3 h-3 ml-2">
                <FAQ />
              </div>
            </LocalizedLink>
            <LocalizedLink
              to={isMonthly ? '/hotel' : '/monthly'}
              className="flex items-center mt-4 text-xs"
              onClick={closeMenu}
            >
              <span> ＜ </span>
              <span className="ml-2">
                {isMonthly ? 'Hotel Plan' : 'Monthly Plan'}
              </span>
            </LocalizedLink>
          </div>
        </div>
      )}

      <div className="mt-10 text-sm w-full">
        <div className="flex justify-between items-center mb-4">
          {/* <div>
            <p className="text-sm font-medium">Connect and Chat</p>
            <div className="flex mt-2 space-x-2">
              <div className="w-6 h-6">
                <WhatsAppIcon />
              </div>
              <div className="w-6 h-6">
                <LineIcon />
              </div>
            </div>
          </div> */}
        </div>
        <div className="flex justify-between items-center">
          <LocalizedLink
            to="/inquiry"
            className="underline"
            onClick={closeMenu}
          >
            Contact Form
          </LocalizedLink>
          <div className="flex space-x-4">
            <LocalizedLink
              to={enPath}
              className={`${currentLang === 'en' ? 'underline' : ''}`}
              onClick={closeMenu}
            >
              EN
            </LocalizedLink>
            <LocalizedLink
              to={jaPath}
              className={`${currentLang === 'ja' ? 'underline' : ''}`}
              onClick={closeMenu}
            >
              JP
            </LocalizedLink>
          </div>
        </div>
        <div className="mt-4">
          <p className="text-xs">c. The Apartment Hotel</p>
        </div>
      </div>
    </div>
  );
};
